import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '~/components/ui/dialog'

type IProps = {
  open: boolean
  title: string
  children: ReactNode
  confirmLabel: string
  /** L'action est en cours : le bouton ne la relance pas. */
  pending?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/** Demande confirmation avant une action qu'on ne défait pas d'un clic (remplacer un secret…). */
function ConfirmDialog({ open, title, children, confirmLabel, pending = false, onConfirm, onCancel }: IProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={next => !next && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{children}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>{t('common.cancel')}</Button>
          <Button variant="destructive" onClick={onConfirm} disabled={pending}>{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDialog
